(function() {
  const drawer = document.getElementById('savvyy-search-drawer');
  const overlay = document.getElementById('savvyy-search-overlay');
  const closeBtn = document.getElementById('savvyy-search-close');
  const input = document.getElementById('savvyy-search-input');
  const suggestions = document.getElementById('savvyy-search-suggestions');
  const predictive = document.getElementById('savvyy-search-predictive');
  const triggers = document.querySelectorAll('[data-search-drawer-trigger]');

  if (!drawer || !overlay) return;

  let debounceTimer = null;

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { input.focus(); }, 300);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    input.value = '';
    showSuggestions();
  }

  function showSuggestions() {
    suggestions.style.display = '';
    predictive.style.display = 'none';
    predictive.innerHTML = '';
  }

  function showPredictive() {
    suggestions.style.display = 'none';
    predictive.style.display = '';
  }

  function fetchResults(query) {
    if (!query || query.length < 2) {
      showSuggestions();
      return;
    }

    showPredictive();
    predictive.innerHTML = '<div class="savvyy-search-drawer__loading">Searching...</div>';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor,tag')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var products = data.resources.results.products || [];
        if (products.length === 0) {
          predictive.innerHTML = '<div class="savvyy-search-drawer__no-results">No results found</div>';
          return;
        }

        var html = '<h3 class="savvyy-search-drawer__predictive-title">Are you looking for...</h3>';
        html += '<div class="savvyy-search-drawer__product-grid">';

        products.forEach(function(product) {
          var img = product.image || '';
          var price = product.price;
          var formattedPrice = '';
          if (price) {
            // /search/suggest.json returns price as a decimal string in the
            // store's major currency unit (e.g. "545.00"), NOT in paise —
            // so it must NOT be divided by 100.
            formattedPrice = '₹ ' + parseFloat(price).toLocaleString('en-IN', { minimumFractionDigits: 2 });
          }

          html += '<a href="' + product.url + '" class="rp__card savvyy-search-drawer__product-card">';
          html += '<div class="rp__img-wrap">';
          if (img) {
            html += '<img src="' + img + '" alt="' + product.title + '" loading="lazy" class="rp__img">';
          }
          html += '</div>';
          html += '<div class="rp__info">';
          if (formattedPrice) {
            html += '<p class="rp__price">' + formattedPrice + '</p>';
          }
          html += '<h3 class="rp__title">' + product.title + '</h3>';
          html += '</div></a>';
        });

        html += '</div>';
        predictive.innerHTML = html;
      })
      .catch(function() {
        predictive.innerHTML = '<div class="savvyy-search-drawer__no-results">Something went wrong</div>';
      });
  }

  // Event listeners
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    });
  });

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  input.addEventListener('input', function() {
    var query = this.value.trim();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      fetchResults(query);
    }, 300);
  });
})();
